import type { ThemeDefinition } from "./types";
import { hexToSrgb, hexToLinear } from "./palette";

export const salt: ThemeDefinition = {
  label: "Salt",
  className: "theme-salt",
  bg: "#e8f0f4",
  text: "#28707c",
  textMuted: `color-mix(in srgb, #28707c 60%, transparent)`,
  accent: "#c07048",
  glassRgb: "232,240,244",
  border: "rgba(255,255,255,0.50)",
  borderHighlight: "rgba(255,255,255,0.50)",
  separator: `color-mix(in srgb, #28707c 30%, transparent)`,
  selection: "#28707c",
  selectionText: "#ffffff",
  gridColor: "#c0d8e0",
  noiseOpacity: "0.03",
  gridOpacity: "0.7",
  textShadow: "0 -1px 0px rgba(255,255,255,0.4), 0 10px 0px rgba(10,30,35,0.15)",
  gpuClear: hexToSrgb("#e8f0f4"),
  gpuGridLine: hexToLinear("#c0d8e0"),
  gpuGridAlpha: 0.7,
  gpuAxisX: hexToLinear("#c07048"),
  gpuAxisZ: hexToLinear("#28707c"),
  axisXColor: "#c07048",
  axisZColor: "#28707c",
  font: '"Space Grotesk", sans-serif',
};
